import styled from 'styled-components'
import { S_NoteEditor } from '../NoteEditor'

export const S_NoteListWrapper = styled.div`
  ${S_NoteEditor} {
    margin-bottom: 20px;
  }
`
